<template>
  <step-container heading="Contact Types">
    <template v-slot:description>
      <p>Contact types allow you to organize your contacts and give them extra fields.</p>
      <p>There are two versions of Contact Types: Seller and Other. If a contact has a Seller Contact Type then the won't show up in the contacts table by default.</p>
      <p>You'll also need to have a default Seller Contact Type that Forefront will use when a lead is created automatically.</p>
    </template>

    <div class="flex flex-between flex-vertical-end mb-200">
      <form-field-select
        label="Type"
        class="mb-0"
        v-model="form.type"
      >
        <option :value="ENUMS.ContactTypeEnum.Other.value">Other</option>
        <option :value="ENUMS.ContactTypeEnum.Seller.value">Seller</option>
      </form-field-select>

      <form-field-input
        label="Label"
        class="mb-0 mx-150 flex-grow"
        v-model="form.label"
      ></form-field-input>

      <div class="mt-100 flex flex-end">
        <button-outlined @click="addType">Add Type</button-outlined>
      </div>
    </div>

    <step-list-section
      heading="Seller Types"
    >
      <step-item-contact-type
        v-for="contactType in sellerTypes"
        :key="contactType.label"
        :contact-type="contactType"
      />
    </step-list-section>

    <step-list-section
      heading="Other Types"
    >
      <step-item-contact-type
        v-for="contactType in otherTypes"
        :key="contactType.label"
        :contact-type="contactType"
      />
    </step-list-section>
  </step-container>
</template>

<script>
import {defineComponent} from 'vue'
import StepContainer from "../component/StepContainer.vue";
import StepListSection from "../component/StepListSection.vue";
import {ENUMS} from "../../../services/enums";
import StepItemContactType from "../component/StepItemContactType.vue";

export default defineComponent({
  name: "OnboardingStepContactTypes",
  components: {StepItemContactType, StepListSection, StepContainer},
  data() {
    return {
      form: {
        include: true,
        isDefault: false,
        label: '',
        type: ENUMS.ContactTypeEnum.Other.value,
      },
    }
  },
  computed: {
    contactTypes() {
      return this.$store.state.onboarding.provisionData.types;
    },
    sellerTypes() {
      return this.contactTypes[ENUMS.ContactTypeEnum.Seller.key];
    },
    otherTypes() {
      return this.contactTypes[ENUMS.ContactTypeEnum.Other.key];
    },
  },
  methods: {
    addType() {
      if(this.form.type === ENUMS.ContactTypeEnum.Other.value) {
        delete this.form.isDefault;
      }

      this.$store.commit('onboarding/addContactType', this.form);

      this.form = {
        include: true,
        label: '',
        type: ENUMS.ContactTypeEnum.Other.value,
      }
    }
  },
})
</script>

<style scoped lang="scss">
.default_type {
  min-width: 210px;
  padding: 0 10px;

  &--wrapper {
    margin: -6px 0 12px;
  }

  &--select {
    min-width: 120px;
  }
}
</style>
